<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter justify-center items-center">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-2/5 m-4">
      <vx-card>

        <div v-if="currentConfig && currentConfig.logo" class="vx-card__title mb-6">
          <div style="text-align: center;"><img :src="currentConfig.logo" style="max-width: 300px; margin: auto;"></div>
          <br>
        </div>

        <div v-if="currentConfig === null">
          <vs-alert>Oops. An error has occured, please contact us directly.</vs-alert>
        </div>
        <div v-else>

          <div v-if="!submitSuccess" class="subscription">
            <h4 class="text-center">Oops, we might have sent you too much e-mail</h4>
            <br>
            <p>We apologize. We invite you to choose between the following options:</p>
            <vs-divider position="center"></vs-divider>

            <p v-for="question in currentConfig.questions ">
              <vs-radio v-model="selectedOption" :vs-value="question.action">{{ question.label }}</vs-radio>
            </p>


            <p><b>OR</b></p>

            <p>
              <vs-radio v-model="selectedOption" vs-value="stop">I do not wish to receive information anymore</vs-radio>
            </p>

            <div v-if="feedback_question">
              <vs-divider position="center"></vs-divider>

              {{ feedback_question }}
              <vs-textarea v-model="user_feedback"></vs-textarea>

            </div>

            <vs-divider position="center"></vs-divider>


            <vs-input v-model="email" v-validate="'email'" class="w-full mb-4"
                      label="Must be a valid email" label-placeholder="Email" name="email" type="email"/>

            <span v-show="errors.has('email')" class="text-danger text-sm">{{ errors.first('email') }}</span>


            <vs-divider position="center"></vs-divider>


            <vs-button :disabled="email.length === 0 ||selectedOption === '' || errors.has('email')" class="w-full" @click.prevent="submitForm">Confirmer</vs-button>

          </div>
        </div>

        <vs-alert :active.sync="submitSuccess" color="success">
          Thank you, your preferences have been updated.
        </vs-alert>
      </vx-card>
    </div>
  </div>
</template>


<script>
import { Base64 } from 'js-base64'
import axios from 'axios'
import moment from 'moment'

//
// Oups! Nous vous avons peut-être communiqué trop de courriels; nous en sommes sincèrement désolés. Nous vous invitons à choisir parmi ces 6 options:
//
//   Ne pas me contacter avant 2021
// Contact me in English Only
// M'informer uniquement sur les formations en ligne offertes
// Mes coordonnées ont changé
// M'informer à une fréquence maximale de 6 courriels par année
// OU
// Ne plus jamais recevoir de courriels de votre part
// Adresse courriel:
//
//
//
//   Oops, we might have sent you too much e-mail; we apologize. We invite you to choose between the following options:
//
//   Let me know only in 2021
// Contact me in English Only
// Let me know only about online workshops available
// My contact details have changed
// OR
// I do not wish to receive information anymore
export default {

  data () {
    const nextTimeOptionLabel = () => { // duplicate with english
      const year  = moment().year()
      const month = moment().month() + 1
      let label   = 'Let me know only in '

      if (month < 6 || month === 12) {
        label += 'fall '
      }

      return label + (year + (month === 12 ? 1 : 0))
    }
    const defaultQuestions    = [
      {
        label:             nextTimeOptionLabel(),
        action:            'next_season',
        feedback_question: ''
      },
      {
        label:             'My contact details have changed',
        action:            'contact_detail_changed',
        feedback_question: 'Please enter your new contact details (email, phone or address) we will update them and get back to you very soon.'
      },
      {
        label:             'Notify me at a maximum frequency of 6 emails per year',
        action:            '6_per_year',
        feedback_question: null
      }
    ]

    return {
      config: {
        'communications.newera.systems':          {
          name:      'newera.systems',
          logo:      '/clients/logos/newera.png',
          questions: defaultQuestions
        },
        'communications.lepresent.com':           {
          name:      'lepresent.com',
          logo:      '/clients/logos/lepresent.png',
          questions: defaultQuestions
        },
        'communications.grouperp.ca':             {
          name:      'grouperp.ca',
          logo:      '/clients/logos/grouperp.png',
          questions: defaultQuestions
        },
        'communications.constructeurvirtuel.com': {
          name:      'constructeurvirtuel.com',
          logo:      '/clients/logos/constructeurvirtuel.png',
          questions: defaultQuestions
        },
        'communications.oncode.ca':               {
          name:      'oncode.ca',
          logo:      '/clients/logos/oncode.png',
          questions: defaultQuestions
        }
      },

      currentConfig:     null,
      feedback_question: null,
      currentHost:       '',
      submitSuccess:     false,
      email:             '',
      communication_id:  null,
      user_feedback:     '',
      selectedOption:    ''
    }
  },

  components: {},
  mounted () {
    if (this.$route.query._neSessId) {
      this.email = Base64.decode(this.$route.query._neSessId)
    }

    if (this.$route.query._neCommId) {
      this.communication_id = this.$route.query._neCommId
    }

    this.currentHost = location.host

    if (this.currentHost.startsWith('192.168.1.')) {
      this.currentHost = 'communications.newera.systems'
    }

    this.currentConfig = this.config[this.currentHost]
  },
  methods: {

    async save () {

      axios.post('https://us-central1-newera-subscription-manager.cloudfunctions.net/updateSubscription', {
        origin: {
          organization: this.currentConfig.name,
          app: 'subscription-manager',
          version: '1.0'
        },
        action:       this.selectedOption,
        info:         {
          language:         'en',
          email:            this.email,
          user_feedback:    this.user_feedback,
          communication_id: this.communication_id
        }
      })
        .then(() => {
          this.submitSuccess = true
        })
        .catch(function (error) {
          alert(error)
        })

    },
    submitForm () {
      this.$validator.validateAll().then(result => {
        if (result) {
          // if form have no errors
          this.save()
        } else {
          // form have errors
        }
      })
    }

  },
  watch:   {
    selectedOption () {
      this.feedback_question = null
      if (this.selectedOption === 'stop') {
        this.feedback_question = ' If you want, you can share your experience with us and help us improve.'
      } else {
        this.currentConfig.questions.forEach(q => {
          if (q.action === this.selectedOption && q.feedback_question) {
            this.feedback_question = q.feedback_question
          }
        })
      }
    }
  } // watch
}

</script>


